import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { track } from './lib/track';
import './styles/index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Anonymous "app opened" signal for knaxly.dev usage analytics.
track('opened');
